<template>
  <div class="no-select home">
      <v-wait for="project-load">
        <template slot="waiting">
          <div class="vh-100 dt w-100 aspect-ratio--object bg-black" style="z-index: 100000;">
            <div class="dtc v-mid tc ph3 ph4-l">
              <h1 class="f6 f2-m f-subheadline-l fw6 tc txt-green ttu">Loading</h1>
            </div>
          </div>
        </template>
          <article class="vh-100 dt w-100 aspect-ratio--object fixed">
            <!-- <span class="w-100 dtc v-mid tr h-auto">
              <img src="@/assets/arrow_up.png">
            </span> -->
            <div class="w-100 dtc v-mid tr" v-if="showImg">
              <!-- <h1 id="stripe" class="fr bg-purple w-50" :class="{ 'purple-bg-invert': invert }" style="opacity: 0.8;"></h1> -->
              <img id="arrow-up" src="@/assets/arrow_up.png" class="animate__animated" style="opacity: 0.8; max-width: 80px; margin-right: 2rem;"><br>
              <img id="stripe" :src="imgUrl" class="w-50-l w-100" :class="{ 'invert-filter': invert == true }">
              <img id="stripe_mobile" src="@/assets/bar_mobile.png" class="w-100" :class="{ 'invert-filter': invert == true }">
              <br>
              <img id="arrow-down" src="@/assets/arrow_down.png" class="w-10 animate__animated" style="opacity: 0.8; max-width: 80px; margin-right: 2rem;">
            </div>
            <!-- <span class="w-100 dtc v-mid tr h-auto">
              <img src="@/assets/arrow_down.png">
            </span> -->
          </article>
          <div id="scroll-indicator" class="scroll-indicator aspect-ratio--object fixed animate__animated" v-if="showScrollIndicator" :style="{ opacity: scrollOpacity }" style="z-index: 150;">
                <div v-if="!mobile" class="w-40 fl vh-100 dt">
                  <div class="dtc v-mid w-100">
                    <img class="w-90 dtc v-mid" src="@/assets/mangled_text.png">
                  </div>
                </div>
                <div class="w-100 w-100-m w-60-l fr-l" style="height: 120vh; margin-top: -1.8rem;">
                  <div v-if="!mobile" class="w-100 h-auto dtc v-mid">
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 3rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 6rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 9rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 12rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 15rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 18rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 21rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 24rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 27rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 30rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 33rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 36rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 39rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 42rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 45rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 48rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 51rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 54rem;">SCROLL</h1>
                  </div>
                  <div v-if="mobile" class="w-100 h-auto dtc v-mid" style="margin-left: -6rem;">
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 1.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 3rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 4.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 6rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 7.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 9rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 10.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 12rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 13.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 15rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 16.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 18rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 19.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 21rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 22.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 24rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 25.5rem;">SCROLL</h1><br>
                    <h1 class="scroll-heading black no-underline mv0 dib txt-invert ttu" style="margin-left: 27rem;">SCROLL</h1>
                  </div>
                </div>
              </div>
            <main class="Loop scroll-loop">

              <section
                   class="project-row bg-center cover hide-child aspect-ratio--object white is-clone">
              </section>
              <section v-for="(project, index) in allProjects" v-bind:key="project.uid"
                   class="project-row cover hide-child pointer aspect-ratio--object white tr dib"
                   @click="goToProject(index)">
                   <h1 class="project-heading ttu white tr f-6-l f-5-m f1 mb0" v-html="project.data.client"
                       :class="{ 'txt-invert': invert }"></h1>
                   <p class="ttu white tr w-100-ns w-70 f4-l f5-m f6 b mt0 dib" :class="{ 'txt-invert': invert }">{{project.data.project_title}}</p>
              </section>

              <!-- FIRST AND SECOND ITEM AS CLONES -->
              <section
                   class="project-row bg-center cover hide-child pointer aspect-ratio--object white is-clone"
                   @click="goToProject(0)">
              </section>
            </main>
          <div class="aspect-ratio--object" style="z-index:1 !important;">
            <div v-for="(project, index) in allProjects" v-bind:key="project.uid" v-show="thumbnail == index">
              <img class="project-img child" :class="{ 'invert-filter': invert }"
                   :src="project.data.project_thumbnail.url"
                   :style="{ top: getRandomInt(0,50) + 'vh', left: getRandomInt(0,57) + 'vw' }"/>
            </div>
          </div>
          <div class="project-page" v-show="currentProjectIndex != -1">
            <Project  v-for="(project, index) in allProjects"
                      v-bind:key="project.uid"
                      v-show="currentProjectIndex == index"
                      :project="project"
                      v-on:nextProject="goToNextProject()"
                      v-on:prevProject="goToPrevProject()"
                      v-on:closeProject="closeProject()"
                      ></Project>
            <!-- <Project :projects="allProjects" :currentProjectIndex="currentProjectIndex"></Project> -->
          </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
// import vuescroll from 'vuescroll';
import Project from '@/components/Project.vue'
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'home',
  components: {
    // vuescroll,
    Project
  },
  data() {
    return {
      currentProject: null,
      currentProjectIndex: -1,
      allProjects: [],
      targetTitle: '',
      doc           : window.document,
      context       : null,
      clones        : null,
      disableScroll : false,
      scrollHeight  : 0,
      scrollPos     : 0,
      clonesHeight  : 0,
      thumbnail     : -1,
      stripeBox: null,
      projectTitles: [],
      collisionMap: [],
      invert: true,
      scrollBuffer: 0,
      showScrollIndicator: true,
      scrollOpacity: 1,
      showImg: false,
      imgUrl: null,
      mobile: isMobile
    }
  },
  methods: {
    goToProject(projectId) {
      // this.$router.push({ name: 'project', params: { project_id: projectId } });

      this.$emit('invert');
      this.invert = true;

      // document.body.style.position = 'fixed';
      // document.body.style.top = `-${window.scrollY}px`;
      document.body.style.overflow = 'hidden';

      var self = this;
      setTimeout(function() {
        self.currentProjectIndex = projectId;
      }, 750);
    },
    goToNextProject() {
      if (this.currentProjectIndex == this.allProjects.length - 1) {
        this.currentProjectIndex = 0;
      }
      else {
        this.currentProjectIndex += 1;
      }
    },
    goToPrevProject() {
      if (this.currentProjectIndex == 0) {
        this.currentProjectIndex = this.allProjects.length - 1;
      }
      else {
        this.currentProjectIndex -= 1;
      }
    },
    closeProject() {
      this.currentProjectIndex = -1;
      this.$emit('invert');
      this.invert = false;
    },
    getImgUrl(pet) {
      var images = require.context('../assets/gifs/', false, /\.gif$/);
      if (pet != null) {
        return images('./' + pet);
      }
      else {
        return images('./smirnoff.gif');
      }
    },
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    showThumbnail (index) {
      this.thumbnail = index;
    },
    hideThumbnail (index) {
      this.thumbnail = -1;
    },
    getScrollPos () {
      return (this.context.pageYOffset || this.context.scrollTop) - (this.context.clientTop || 0);
    },
    setScrollPos (pos) {
      this.context.scrollTop = pos;
    },
    getClonesHeight () {
      this.clonesHeight = 0;

      for (var i = 0; i < this.clones.length; i += 1) {
        this.clonesHeight = this.clonesHeight + this.clones[i].offsetHeight;
      }

      return this.clonesHeight;
    },
    reCalc () {
      this.scrollPos    = this.getScrollPos();
      this.scrollHeight = this.context.scrollHeight;
      this.clonesHeight = this.getClonesHeight();

      if (this.scrollPos <= 0) {
        this.setScrollPos(1); // Scroll 1 pixel to allow upwards scrolling
      }
    },
    scrollUpdate () {
      if (!this.disableScroll) {
        this.scrollPos = this.getScrollPos();

        if (this.clonesHeight + this.scrollPos >= this.scrollHeight) {
          // Scroll to the top when you’ve reached the bottom
          this.setScrollPos(1); // Scroll down 1 pixel to allow upwards scrolling
          this.disableScroll = true;
        } else if (this.scrollPos <= 0) {
          // Scroll to the bottom when you reach the top
          this.setScrollPos(this.scrollHeight - this.clonesHeight);
          this.disableScroll = true;
        }
      }

      var that = this;

      if (this.disableScroll) {
        // Disable scroll-jumping for a short time to avoid flickering
        window.setTimeout(function () {
          that.disableScroll = false;
        }, 40);
      }
    },
    init () {
      this.reCalc();

      var that = this;

      window.addEventListener('scroll', function () {
        that.checkCollision();
      }, false);
    },
    checkCollision () {
      var doc = window.document;
      var projectTitles = doc.querySelectorAll('.project-heading');

      if (!isMobile) {
        var stripe = doc.getElementById("stripe");
      }
      else {
        var stripe = doc.getElementById("stripe_mobile");
      }

      for (var i = 0; i < projectTitles.length; i++) {
        if (this.is_colliding(stripe, projectTitles[i]) && this.thumbnail == -1) {
          this.collisionMap[i] = true;
          this.thumbnail = i;

          if (this.showScrollIndicator == true) {
            this.showScrollIndicator = false;
            this.scrollBuffer = 29;
            this.$emit('scrolling');
            this.invert = false;

            var arrow_up = document.getElementById("arrow-up");
            arrow_up.classList.add("invert-filter");
            arrow_up.classList.add("animate__fadeOutUp");

            var arrow_down = document.getElementById("arrow-down");
            arrow_down.classList.add("invert-filter");
            arrow_down.classList.add("animate__fadeOutDown");
          }
        }
        // else if (!this.is_colliding(stripe, projectTitles[i]) && this.thumbnail != -1) {
        //   this.collisionMap[i] = false;
        // }
        else if (!this.is_colliding(stripe, projectTitles[i]) && this.thumbnail == i) {
          this.collisionMap[i] = false;
          this.thumbnail = -1;
        }
      }
    },
    is_colliding ( $div1, $div2 ) {
      var div1_selection = $div1.getBoundingClientRect();
      var div2_selection = $div2.getBoundingClientRect();

      if( div2_selection.top + div2_selection.height > (div1_selection.top + 30)
          && div2_selection.left + div2_selection.width > div1_selection.left
          && div2_selection.bottom - div2_selection.height < (div1_selection.bottom - 40)
          && div2_selection.right - div2_selection.width < div1_selection.right) {
        return true;
      }
      else {
        return false;
      }
    },
    preloadAssets (cb) {
      var assets = [
        'assets/bar.png',
        'assets/bar_mobile.png',
        'assets/arrow_up.png',
        'assets/arrow_down.png',
        'assets/mangled_text.png',
        'assets/contact-texture.png'
      ];

      var images = [];

      for (var i = 0; i < assets.length; i++) {
        // console.log('loading asset');
        images[i] = new Image();

        images[i].addEventListener('load', function() {
          // console.log('img loaded');
          // Here you can reveal the image
          // this.imgUrl = images[i].src;
          // this.showImg = true;
        }, false);

        images[i].src = require('../' + assets[i]);

        // images.push(img);
      }

      // console.log(images);
      this.showImg = true;
      this.imgUrl = images[0].src;
      cb();
    }
  },
  created() {
    var that = this;

    this.$wait.start('project-load');

    this.$store.dispatch('fetchProjects', { vm: this, cb:
      function(results) {
        that.allProjects = results;
        // that.allProjects.push(that.allProjects[0]);
        // that.allProjects.push(that.allProjects[1]);

        //initialize collision map
        for (var i = 0; i < that.allProjects.length; i++) {
          that.collisionMap[i] = false;

          // that.allProjects[i].data.client = that.allProjects[i].data.client.replaceAll(' ', '<br>');
          that.allProjects[i].data.client = that.allProjects[i].data.client.replace(/ /g, '<br>');
        }

      }
    });
  },
  mounted() {

      var self = this;
      var interval = null;

      this.preloadAssets(function() {
        setTimeout(function() {
          // console.log('pulling load');
            self.$wait.end('project-load');
        }, 2500);
      });

      var doc = window.document;
      self.context = doc.querySelector('.scroll-loop');

      if (self.context != null) {
        clearInterval(interval);
        self.clones  = self.context.querySelectorAll('.is-clone');

        if (document.readyState !== 'loading') {
          self.init()
        } else {
          doc.addEventListener('DOMContentLoaded', self.init, false)
        }
      }
      else {
        interval = setInterval(function() {
          self.context = doc.querySelector('.scroll-loop');

          if (self.context != null) {
            clearInterval(interval);
            self.clones  = self.context.querySelectorAll('.is-clone');

            if (document.readyState !== 'loading') {
              self.init()
            } else {
              doc.addEventListener('DOMContentLoaded', self.init, false)
            }
          }
        }, 250);
      }
    // }, 1500);

  },
  destroyed() {

  },
  // events: {
  //   nextProject: function () {
  //     // logic
  //     this.goToNextProject();
  //   },
  //   prevProject: function () {
  //     // logic
  //     this.goToPrevProject();
  //   }
  // }
}
</script>
<style>
html,
body {
  height: 100%;
  /*overflow: hidden;*/
  margin: 0;
}

body {
  font-family: "Avenir Next", Helvetica, sans-serif;
  font-weight: normal;
  font-size: 100%;
}

::scrollbar {
  display: none;
}

div {
  position: relative;
  height: 100%;
  /*overflow: auto;*/
}

</style>
<style scoped>

/********************* START LOOP SCROLL CSS *********************/


section {
  position: relative;
  /*text-align: right;*/
  min-height: 600px;
  max-height: 700px;

  /*padding-right: 2.3rem;*/
  padding-right: 0rem;

  /*min-height: 53vh;
  max-height: 56vh;*/
  height: 80%;
}

.Loop {
  position: relative;
  height: 100%;
  /*overflow: auto;
  -webkit-overflow-scrolling: touch;*/
}

.red {
  background: #FF4136;
}
.green {
  background: #2ECC40;
}
.blue {
  background: #0074D9;
}
.orange {
  background: rebeccapurple;
}

h2 {
  margin: 0;
  /*position: absolute;
  top: 50%;
  right: 2%;*/
  transform: translateY(-50%);
  /*width: 100%;*/

  /*width: 37%;
  font-size: 80px;*/

  text-align: right;
  padding-right: 4px;

  width: 100%;
  font-size: 8rem;

  font-weight: 700;
  letter-spacing: 0px;
  /*color: #000;*/
  /*text-transform: uppercase;*/
  /*text-shadow: 0px 0px 2px rgba(160, 160, 160, 1);*/
}

.project-img {
  max-width: 50%;
  position: fixed;
  z-index: 2;
}

.project-heading {
  /*position: relative;*/
  z-index: 2;
  line-height: 0.8;
  /*margin-right: 2.3rem;*/
}

.bg-purple {
  /*background-color: #5B00F6;*/
  background-color: #5300e9;
}

.purple {
  /*color: #5B00F6;*/
  color: #5300e9;
}

.project-page {
  z-index: 110;
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  background-color: rgba(0,0,0,0.9);
  height: 100vh;
  overflow: scroll;
}

#stripe {
  /*padding-top: 9rem;
  padding-bottom: 9rem;*/
  /*max-width: 1024px;
  width: 100%;*/
  opacity: 0.8;
  display: none;
}

#stripe_mobile {
  display: block;
  opacity: 0.8;
}

.scroll-heading {
  font-size: 4rem;
}

/*ns breakpoint*/
@media screen and (min-width: 30em) {
  section {
    position: relative;
    /*text-align: right;*/
    min-height: 600px;
    max-height: 700px;

    padding-right: 2.3rem;

    /*min-height: 53vh;
    max-height: 56vh;*/
    height: 80%;
  }

  #stripe {
    display: inline-block;
  }

  #stripe_mobile {
    display: none;
  }

  .scroll-heading {
    font-size: 9rem;
  }
}

/*medium breakpoint*/
@media screen and (min-width: 30em) and (max-width: 60em) {
  section {
    position: relative;
    /*text-align: right;*/
    min-height: 600px;
    max-height: 700px;

    padding-right: 0;

    /*min-height: 53vh;
    max-height: 56vh;*/
    height: 80%;
  }

  #stripe {
    display: none;
  }

  #stripe_mobile {
    display: block;
  }

  .scroll-heading {
    font-size: 6rem;
  }
}

/*.project-row:hover .project-heading {
  opacity: 1;
}*/

/********************* END LOOP SCROLL CSS *********************/


  /*.disable-hover {
    pointer-events: none;
  }

  img {
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
  }

  .specificLocation {
    margin-left: 100px;
  }

  .fit {
    -o-object-fit: contain;
    object-fit: contain;
  }

  #photo_landscape { display: block; }
  #photo_vertical { display: none; }

  .no-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  @media screen and (max-width: 768px) {
    #photo_landscape { display: none; }
    #photo_vertical { display: block; }
  }*/
</style>
